export default "__VITE_ASSET__6cd165db__"